import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { UPLOAD_SURGE_FILE, UPLOAD_SURGE_FILE_SUCCESS, UPLOAD_SURGE_FILE_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* uploadSurgeFile({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/fileupload-surge`,
      method: 'POST',
      isFormData: true,
      data: payload?.data,
      params: payload?.urlParams,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 202) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: UPLOAD_SURGE_FILE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: UPLOAD_SURGE_FILE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPLOAD_SURGE_FILE_ERROR, payload: error });
  }
}

export function* watchuploadSurgeFile() {
  yield takeEvery(UPLOAD_SURGE_FILE, uploadSurgeFile);
}

function* uploadSurgeFileSaga() {
  yield all([fork(watchuploadSurgeFile)]);
}

export default uploadSurgeFileSaga;
